export class FormParams {
  userInput: any;
  dimension?: any;
  customerId?: any;
  dimensions?: any;
  inputs?: any;
  page?: any;
  type?: any;
}
